// extracted by mini-css-extract-plugin
export var center = "purpose-content-module--center--d2f7a";
export var flexContainer = "purpose-content-module--flex-container--e5f8d";
export var instaHeading = "purpose-content-module--insta-heading--428a9";
export var instaIcon = "purpose-content-module--insta-icon--e65eb";
export var instaRichtext = "purpose-content-module--insta-richtext--f016b";
export var purposeInstagram = "purpose-content-module--purpose-instagram--b2c9b";